export default {
    es: {
        auth: {
            sessionExpired: "La sesión {session_key} ha expirado el {expire_date}",
            invalidSessionKey: "Clave de sesión inválida: {session_key}",
            userNotFound: "Usuario no encontrado",
            incorrectPassword: "Contraseña incorrecta",
            fieldNotEditable: "El campo {field} no es editable",
            userUpdated: "Usuario actualizado exitosamente",
            resetEmailSent: "Se envió el enlace de restablecimiento al correo registrado: {email}",
            invalidOrExpiredToken: "Token inválido o expirado",
            passwordResetSuccess: "Contraseña restablecida exitosamente",
            superuserOnly: "Solo los superusuarios pueden generar tokens",
            superuserOnlyCreateUsers: "Solo los superusuarios pueden crear usuarios",
            targetUserNotFound: "No se encontró el usuario para generar el token",
            pleaseProvideCredentials: "Por favor proporciona usuario y contraseña",
            accountNotActivated: "Por favor verifica tu correo electrónico antes de iniciar sesión",
            sessionKeyGenerationError: "Error al generar la clave de sesión",
            loginSuccessful: "Inicio de sesión exitoso",
            loggedOutSuccessfully: "Sesión cerrada exitosamente",
            invalidJson: "Formato JSON inválido",
            fieldRequired: "Este campo es obligatorio",
            passwordsDoNotMatch: "Las contraseñas no coinciden",
            usernameAlreadyTaken: "El nombre de usuario ya está en uso",
            emailAlreadyRegistered: "El correo electrónico ya está registrado",
            userCreationFailed: "Error al crear el usuario. Por favor intenta de nuevo.",
            userCreated: "Usuario creado exitosamente",
            passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
            companyNotFound: "La empresa seleccionada no existe",
            userUpdateFailed: "Error al actualizar el perfil. Por favor intenta de nuevo.",
            passwordChanged: "Contraseña actualizada correctamente",
            passwordChangeFailed: "Error al cambiar la contraseña. Por favor intenta de nuevo.",
            registrationSuccess: "¡Registro exitoso! Por favor revisa tu correo para activar tu cuenta.",
            accountActivatedSuccess: "Cuenta activada exitosamente",
            invalidActivationLink: "Enlace de activación inválido",
            emailRequired: "El correo electrónico es obligatorio",
            accountAlreadyActive: "La cuenta ya está activa",
            activationEmailResent: "Correo de activación reenviado. Por favor revisa tu bandeja de entrada.",
            activationEmailSubject: "Activa tu cuenta de Kiplan",
            resendActivationEmailSubject: "Activa tu cuenta de Kiplan - Reenvío",
            healthOk: "ok",
            accountInactive: "Por favor activa tu cuenta con el enlace que te enviamos al correo electrónico para iniciar sesión",
        },
        login: {
            welcomeBack: "Bienvenido",
            logInToAccount: "Inicia sesión en tu cuenta",
            email: {
                label: "Correo Electrónico",
                required: "El correo electrónico es obligatorio"
            },
            password: {
                label: "Contraseña",
                required: "La contraseña es obligatoria"
            },
            logInButton: {
                label: "Iniciar Sesión",
                loading: "Iniciando sesión..."
            },
            successMessage: "¡Inicio de sesión exitoso!",
            forgotPassword: "¿Olvidaste tu contraseña?",
            noAccount: "¿No tienes una cuenta?",
            signUp: "Registrarse",
            resendActivation: "Reenviar correo de activación",
            resendPlaceholder: "Por favor ingresa tu correo electrónico.",
            resendFailed: "No se pudo reenviar el correo de activación. Por favor intenta de nuevo.",
            resendUnexpectedError: "Ocurrió un error inesperado. Por favor contacta al soporte.",
            orContinueWith: "o continúa con",
            microsoftError: "Error al iniciar sesión con Microsoft",
            signingIn: "Iniciando sesión..."
        },
        signup: {
            createAccount: "Crear Cuenta",
            subtitle: "Regístrate para comenzar",
            email: {
                label: "Correo Electrónico",
                required: "El correo electrónico es obligatorio",
                invalid: "Por favor ingrese un correo electrónico válido"
            },
            password: {
                label: "Contraseña",
                required: "La contraseña es obligatoria",
                minLength: "La contraseña debe tener al menos 8 caracteres",
                showPassword: "Mostrar contraseña",
                hidePassword: "Ocultar contraseña"
            },
            confirmPassword: {
                label: "Confirmar Contraseña",
                required: "Por favor confirme su contraseña",
                mismatch: "Las contraseñas no coinciden",
                showPassword: "Mostrar confirmación de contraseña",
                hidePassword: "Ocultar confirmación de contraseña"
            },
            signUpButton: {
                label: "Registrarse",
                loading: "Creando cuenta..."
            },
            messages: {
                emailRequired: "Por favor ingrese un correo electrónico válido.",
                passwordMinLength: "La contraseña debe tener al menos 8 caracteres.",
                passwordMismatch: "Las contraseñas no coinciden.",
                csrfError: "No se pudo obtener el token CSRF",
                registrationSuccess: "¡Registro exitoso! Por favor revise su correo electrónico para activar su cuenta.",
                registrationFailed: "Registro fallido. Por favor intente de nuevo.",
                error: "Error"
            },
            login: {
                prompt: "¿Ya tienes una cuenta?",
                button: "Iniciar Sesión"
            }
        },
        accountActivation: {
            subtitle: "Activación de Cuenta",
            activating: "Activando tu cuenta...",
            activated: "¡Cuenta Activada!",
            defaultSuccess: "¡Tu cuenta ha sido activada exitosamente!",
            goToLogin: "Ir al inicio de sesión",
            activationFailed: "Activación Fallida",
            goToSignUp: "Ir a Registro",
            invalidLink: "Enlace de Activación Inválido",
            invalidLinkMessage: "El enlace de activación es inválido o ha expirado.",
            resendEmailLabel: "Ingresa tu correo para reenviar el enlace de activación",
            resendButton: "Reenviar correo de activación",
            resendDefaultSuccess: "Correo de activación reenviado. Por favor revisa tu bandeja de entrada.",
            resendFailed: "No se pudo reenviar el correo de activación. Por favor intenta de nuevo.",
            resendEmailRequired: "Por favor ingresa tu dirección de correo electrónico.",
            missingParams: "Enlace de activación inválido. Faltan parámetros requeridos.",
            unexpectedError: "Ocurrió un error inesperado. Por favor contacta al soporte.",
            failedDefault: "No se pudo activar la cuenta. Por favor intenta de nuevo."
        },
        activateMessage: {
            checkYourEmail: "Revisa tu Correo",
            sentLink: "Hemos enviado un enlace de activación a:",
            instructions: "Por favor haz clic en el enlace del correo para activar tu cuenta.",
            spamNote: "Si no lo ves, revisa tu carpeta de spam.",
            backToLogin: "Volver al inicio de sesión"
        },
        forgotPassword: {
            title: "Olvidé mi Contraseña",
            subtitle: "Ingresa tu correo o nombre de usuario y te enviaremos un enlace para restablecer tu contraseña",
            usernameLabel: "Correo o Nombre de Usuario",
            usernameRequired: "El correo o nombre de usuario es obligatorio",
            sendButton: "Enviar correo con enlace",
            sending: "Enviando...",
            defaultSuccess: "Si el usuario existe, se ha enviado un enlace de restablecimiento a tu correo.",
            defaultError: "Ocurrió un error. Por favor intenta de nuevo.",
            backToLogin: "Volver al inicio de sesión",
            remembered: "¿Recordaste tu contraseña?"
        },
        resetPassword: {
            title: "Restablecer Contraseña",
            subtitle: "Ingresa tu nueva contraseña",
            newPasswordLabel: "Nueva Contraseña",
            confirmPasswordLabel: "Confirmar Contraseña",
            passwordRequired: "La contraseña es obligatoria",
            passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
            confirmRequired: "Por favor confirma tu contraseña",
            passwordMismatch: "Las contraseñas no coinciden",
            resetButton: "Restablecer Contraseña",
            resetting: "Restableciendo...",
            invalidToken: "Token inválido o faltante. Por favor solicita un nuevo enlace de restablecimiento.",
            invalidTokenOnMount: "Token inválido o faltante. Por favor verifica tu enlace de restablecimiento.",
            mismatchError: "Las contraseñas no coinciden.",
            minLengthError: "La contraseña debe tener al menos 8 caracteres.",
            defaultSuccess: "¡La contraseña ha sido restablecida exitosamente!",
            defaultError: "No se pudo restablecer la contraseña. El enlace puede haber expirado.",
            backToLogin: "Volver al inicio de sesión",
            emailLabel: "Correo electrónico"
        },
        logout: {
            title: "Has cerrado sesión",
            message: "Tu sesión se ha cerrado correctamente. Inicia sesión de nuevo para continuar donde lo dejaste.",
            backToLogin: "Volver a iniciar sesión"
        },
    },
    en: {
        auth: {
            sessionExpired: "Session {session_key} expired at {expire_date}",
            invalidSessionKey: "Invalid session key: {session_key}",
            userNotFound: "User not found",
            incorrectPassword: "Incorrect password",
            fieldNotEditable: "Field {field} is not editable",
            userUpdated: "User updated successfully",
            resetEmailSent: "Sent password reset to registered email: {email}",
            invalidOrExpiredToken: "Invalid or expired token",
            passwordResetSuccess: "Password reset successfully",
            superuserOnly: "Only superusers can generate tokens",
            superuserOnlyCreateUsers: "Only superusers can create users",
            targetUserNotFound: "User to generate token for not found",
            pleaseProvideCredentials: "Please provide username and password",
            accountNotActivated: "Please verify your email before logging in",
            sessionKeyGenerationError: "Error while generating session key",
            loginSuccessful: "Login successful",
            loggedOutSuccessfully: "Logged out successfully",
            invalidJson: "Invalid JSON format",
            fieldRequired: "This field is required",
            passwordsDoNotMatch: "Passwords do not match",
            usernameAlreadyTaken: "Username already taken",
            emailAlreadyRegistered: "Email already registered",
            userCreationFailed: "Failed to create user. Please try again.",
            userCreated: "User created successfully",
            passwordTooShort: "Password must be at least 8 characters long",
            companyNotFound: "The selected company does not exist",
            userUpdateFailed: "Failed to update profile. Please try again.",
            passwordChanged: "Password updated successfully",
            passwordChangeFailed: "Failed to change password. Please try again.",
            registrationSuccess: "Registration successful! Please check your email to activate your account.",
            accountActivatedSuccess: "Account activated successfully",
            invalidActivationLink: "Invalid activation link",
            emailRequired: "Email is required",
            accountAlreadyActive: "Account is already active",
            activationEmailResent: "Activation email resent. Please check your inbox.",
            activationEmailSubject: "Activate Your Kiplan Account",
            resendActivationEmailSubject: "Activate Your Kiplan Account - Resend",
            healthOk: "ok",
            accountInactive: "Please activate your account with the link we sent to your email to log in",
        },
        login: {
            welcomeBack: "Welcome Back",
            logInToAccount: "Log in to your account",
            email: {
                label: "Email",
                required: "Email is required"
            },
            password: {
                label: "Password",
                required: "Password is required"
            },
            logInButton: {
                label: "Log In",
                loading: "Logging in..."
            },
            successMessage: "Login successful!",
            forgotPassword: "Forgot password?",
            noAccount: "Don't have an account?",
            signUp: "Sign up",
            resendActivation: "Resend Activation Email",
            resendPlaceholder: "Please enter your email address.",
            resendFailed: "Failed to resend activation email. Please try again.",
            resendUnexpectedError: "Unexpected error occurred. Please contact support.",
            orContinueWith: "or continue with",
            microsoftError: "Microsoft sign-in error",
            signingIn: "Signing in..."
        },
        signup: {
            createAccount: "Create Account",
            subtitle: "Sign up to get started",
            email: {
                label: "Email",
                required: "Email is required",
                invalid: "Please enter a valid email"
            },
            password: {
                label: "Password",
                required: "Password is required",
                minLength: "Password must be at least 8 characters",
                showPassword: "Show password",
                hidePassword: "Hide password"
            },
            confirmPassword: {
                label: "Confirm Password",
                required: "Please confirm your password",
                mismatch: "Passwords do not match",
                showPassword: "Show confirm password",
                hidePassword: "Hide confirm password"
            },
            signUpButton: {
                label: "Sign Up",
                loading: "Creating account..."
            },
            messages: {
                emailRequired: "Please enter a valid email address.",
                passwordMinLength: "Password must be at least 8 characters.",
                passwordMismatch: "Passwords do not match.",
                csrfError: "Unable to obtain CSRF token",
                registrationSuccess: "Registration successful! Please check your email to activate your account.",
                registrationFailed: "Registration failed. Please try again.",
                error: "Error"
            },
            login: {
                prompt: "Already have an account?",
                button: "Log in"
            }
        },
        accountActivation: {
            subtitle: "Account Activation",
            activating: "Activating your account...",
            activated: "Account Activated!",
            defaultSuccess: "Your account has been successfully activated!",
            goToLogin: "Go to Login",
            activationFailed: "Activation Failed",
            goToSignUp: "Go to Sign Up",
            invalidLink: "Invalid Activation Link",
            invalidLinkMessage: "The activation link is invalid or has expired.",
            resendEmailLabel: "Enter your email to resend activation link",
            resendButton: "Resend Activation Email",
            resendDefaultSuccess: "Activation email resent. Please check your inbox.",
            resendFailed: "Failed to resend activation email. Please try again.",
            resendEmailRequired: "Please enter your email address.",
            missingParams: "Invalid activation link. Missing required parameters.",
            unexpectedError: "Unexpected error occurred. Please contact support.",
            failedDefault: "Failed to activate account. Please try again."
        },
        activateMessage: {
            checkYourEmail: "Check Your Email",
            sentLink: "We've sent an activation link to:",
            instructions: "Please click the link in the email to activate your account.",
            spamNote: "If you don't see it, check your spam folder.",
            backToLogin: "Back to Login"
        },
        forgotPassword: {
            title: "Forgot Password",
            subtitle: "Enter your email or username and we'll send you a password reset link",
            usernameLabel: "Email or Username",
            usernameRequired: "Email or Username is required",
            sendButton: "Send Reset Link",
            sending: "Sending...",
            defaultSuccess: "If the user exists, a password reset link has been sent to your email.",
            defaultError: "An error occurred. Please try again.",
            backToLogin: "Back to Login",
            remembered: "Remembered your password?"
        },
        resetPassword: {
            title: "Reset Password",
            subtitle: "Enter your new password below",
            newPasswordLabel: "New Password",
            confirmPasswordLabel: "Confirm Password",
            passwordRequired: "Password is required",
            passwordMinLength: "Password must be at least 8 characters",
            confirmRequired: "Please confirm your password",
            passwordMismatch: "Passwords do not match",
            resetButton: "Reset Password",
            resetting: "Resetting...",
            invalidToken: "Invalid or missing reset token. Please request a new password reset link.",
            invalidTokenOnMount: "Invalid or missing reset token. Please check your reset link.",
            mismatchError: "Passwords do not match.",
            minLengthError: "Password must be at least 8 characters.",
            defaultSuccess: "Password has been successfully reset!",
            defaultError: "Failed to reset password. The link may have expired.",
            backToLogin: "Back to Login",
            emailLabel: "Email"
        },
        logout: {
            title: "You've Logged Out",
            message: "Your session has been closed successfully. Log in again to continue where you left off.",
            backToLogin: "Back to Login"
        },
    },
}
